import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import {
  DELETE_VENDOR_LOG_REQUEST,
  GET_VENDOR_LOG_LIST_REQUEST,
} from "./type";
import {
  deleteVendorLogSuccess,
  getVendorLogListRequest,
  getVendorLogListSuccess,
} from "./action";
import { handleApiCallException } from "../../shared/action";
import { ApiResponseMessage } from "../../../helper/tosterHelper";
import { DANGER, SUCCESS } from "../../../constant/commonConstants";
import { invokeApi } from "../../../helper/axiosHelper";

function* vendorLogList({ payload: data }) {
  try {
    const res = yield call(
      invokeApi,
      "post",
      "/vendorLogList",
      data,
      null,
      "vendor",
    );
    if (res.status) {
      yield put(getVendorLogListSuccess(res.data));
    } else {
      yield put(getVendorLogListSuccess([]));
      ApiResponseMessage(res.message, DANGER);
      handleApiCallException(res.message);
    }
  } catch (error) {
    ApiResponseMessage(error, DANGER);
    yield put(getVendorLogListSuccess([]));
    handleApiCallException(error);
  }
}

function* deleteVendorLog({ payload: data }) {
  try {
    const res = yield call(
      invokeApi,
      "post",
      "/vendorLogDelete",
      {
        vendorId: data.vendorId,
        category: data.category,
        fromDate: data.fromDate,
        toDate: data.toDate,
        searchText: data.searchText,
      },
      null,
      "vendor",
    );
    if (res.status) {
      ApiResponseMessage(res.message, SUCCESS);
      yield put(deleteVendorLogSuccess(res));
      yield put(getVendorLogListRequest(data.listData));
    } else {
      yield put(deleteVendorLogSuccess([]));
      ApiResponseMessage(res.message, DANGER);
    }
  } catch (error) {
    ApiResponseMessage(error, DANGER);
    yield put(deleteVendorLogSuccess([]));
    handleApiCallException(error);
  }
}

function* watchVendorLogRequest() {
  yield takeLatest(GET_VENDOR_LOG_LIST_REQUEST, vendorLogList);
  yield takeLatest(DELETE_VENDOR_LOG_REQUEST, deleteVendorLog);
}

function* AdminVendorLogSaga() {
  yield all([fork(watchVendorLogRequest)]);
}

export default AdminVendorLogSaga;
